"use client";

import { useState, useEffect } from "react";

export function useMediaQuery(query: string): boolean {
    const isClient = typeof window !== "undefined";
    const [matches, setMatches] = useState<boolean>(isClient ? window.matchMedia(query).matches : false);

    useEffect(() => {
        setMatches(window.matchMedia(query).matches);
    }, []);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const updateMatches = (event: MediaQueryListEvent) => {
            setMatches(event.matches);
        };
        mediaQueryList.addEventListener("change", updateMatches);

        return function cleanup() {
            mediaQueryList.removeEventListener("change", updateMatches);
        };
    }, [query]);

    return matches;
}
